export default __webpack_public_path__ + "img/subnets.eb49fb0.svg";